import { Conversation } from '@/explore/types';

import { isExplorationMessage } from './cell';
import { getJobStatus } from './conversation/job';

export const hasRunningJobs = (conversation?: Conversation | null) => {
  return conversation?.jobs.some((job) => getJobStatus(job) === 'running') ?? false;
};

/**
 * Returns the ID of the last exploration cell in the conversation, or undefined if the conversation is not found, or null if there are no exploration cells.
 * @param conversation
 * @returns string | null | undefined
 */
export const getLastExplorationCellId = (conversation?: Conversation) =>
  conversation === undefined
    ? undefined
    : (conversation.messages.findLast(isExplorationMessage)?.exploration.view.cells.at(-1)?.id ??
      null);

export const getCellsFromMessages = (messages: Conversation['messages']) =>
  messages.flatMap((message) =>
    isExplorationMessage(message) ? message.exploration.view.cells : [],
  );
